import { Check, Loader2, X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';

interface ModalActionsProps {
  onCancel: () => void;
  onConfirm?: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  confirmIcon?: ReactNode;
  confirmVariant?: ButtonProps['variant'];
  /** Para o botão submeter o formulário do modal em vez de chamar `onConfirm`. */
  confirmType?: 'button' | 'submit';
  isLoading?: boolean;
  isConfirmDisabled?: boolean;
}

/**
 * Par de botões do rodapé de todo modal — sempre ícone + texto.
 *
 * Cancelar também fica desabilitado durante o envio: deixá-lo ativo permite fechar o
 * modal com a requisição em voo, e a pessoa fica sem saber se a ação valeu.
 */
export function ModalActions({
  onCancel,
  onConfirm,
  cancelLabel = 'Cancelar',
  confirmLabel = 'Confirmar',
  confirmIcon,
  confirmVariant = 'default',
  confirmType = 'button',
  isLoading = false,
  isConfirmDisabled = false,
}: ModalActionsProps) {
  return (
    <>
      <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>
        <X aria-hidden />
        {cancelLabel}
      </Button>

      <Button
        type={confirmType}
        variant={confirmVariant}
        onClick={onConfirm}
        disabled={isConfirmDisabled || isLoading}
      >
        {isLoading ? (
          <Loader2 className="animate-spin" aria-hidden />
        ) : (
          (confirmIcon ?? <Check aria-hidden />)
        )}
        {confirmLabel}
      </Button>
    </>
  );
}
